import * as React from 'react'

const RagisterdTutorIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <rect width="32" height="32" fill="#E0EAFF" rx="16"></rect>
    <path
      stroke="#444CE7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.333"
      d="M22.666 22v-1.333c0-1.243-.85-2.287-2-2.583m-2.333-7.89a2.668 2.668 0 010 4.945m1 6.861c0-1.242 0-1.864-.203-2.354a2.666 2.666 0 00-1.443-1.443C17.197 18 16.576 18 15.333 18h-2c-1.242 0-1.864 0-2.354.203-.653.27-1.172.79-1.443 1.443-.203.49-.203 1.111-.203 2.354M17 12.667a2.667 2.667 0 11-5.334 0 2.667 2.667 0 015.334 0z"
    ></path>
  </svg>
)

export default RagisterdTutorIcon
